var cache = require('../models/cache'),
  cookieHelper = require('cookies-js'),
  log = require("../libraries/logger").getLoggerInstance('Base.StorageUtility'),
  storageHelper = require('simplestorage.js');

// When we load the script we should evaluate the localstorage availablity immedately
if (cache.localStorageAvailable === undefined) {
  cache.localStorageAvailable = storageHelper.canUse();
  log.debug("local storage is " + (cache.localStorageAvailable === true ? "available" : "unavailable"));
}

// NEXTREV: Add option for if cookies are disabled. Most likely would only be in memory storage, but the issue needs to be considered more.   
var publicMethods = {
  /**
   * Persist a KVP to storage that can be restored on a seperate page load
   * @param {string} key The key
   * @param {string} value The value
   * @param {Date=} expiration An optional date time the value should expire
   */
  put: function (key, value, expiration) {
    var currentTime = new Date(),
      options = {},
      elapsedMillis;

    if (cache.localStorageAvailable) {

      if (expiration) {
        elapsedMillis = currentTime.getTime() - expiration.getTime();
        options = {
          TTL: elapsedMillis
        };
      }

      storageHelper.set(key, value, options);
    } else {

      if (expiration) {
        options = {
          expires: expiration
        };
      }

      cookieHelper.set(key, value, options);
    }
  },
  /**
   * Get a KVP out of storage
   * @param {String} key The key to restore from storage
   * @return The value found mapped to the key in storage
   */
  get: function (key) {
    if (cache.localStorageAvailable) {
      return storageHelper.get(key);
    } else {
      return cookieHelper.get(key);
    }
  }
};

module.exports = publicMethods;


//////////////////
// WEBPACK FOOTER
// ./utilities/storageUtility.js
// module id = 65
// module chunks = 5